<template>
  <Adminlte>
    <div class="box">
      <div class="box-header">
        <h3 class="box-title">{{ pageTitle }}</h3>
        <br>
        <img style="cursor: pointer;" :class="[{'low-opacity': this.activeContent !== 'pt' }]" :src="this.$config.imgDir + '/flag-brazil-32.png'" @click="showPtContent">
        <img style="cursor: pointer;" :class="[{'low-opacity': this.activeContent !== 'en' }]" :src="this.$config.imgDir + '/flag-usa-32.png'" @click="showEnContent">
      </div>
      <div>
        <div v-if="this.activeContent === 'pt'" class="box box-solid">
          <div class="box-header with-border">
            <h3 class="box-title">Texto em Portugês</h3>
          </div>
          <div class="box-body pad">
            <vue-html5-editor :content="pageContent.portugueseBody" @change="updatePortugueseData" :height="300"></vue-html5-editor>
          </div>
        </div>
        <div v-if="this.activeContent === 'en'" class="box box-solid">
          <div class="box-header with-border">
            <h3 class="box-title">Texto em Inglês</h3>
          </div>
          <div class="box-body pad">
            <vue-html5-editor :content="pageContent.englishBody" @change="updateEnglishData" :height="300"></vue-html5-editor>
          </div>
        </div>
      </div>
      <div class="box-footer">
        <div class="row">
          <div class="col-xs-10">
            <notifier ref="notifier"></notifier>
          </div>
          <div class="col-xs-2">
            <button type="submit" class="btn btn-primary pull-right" @click="save">Salvar</button>
          </div>
        </div>
      </div>
    </div>
  </Adminlte>
</template>
<script>
import Adminlte from '@/components/template/Adminlte'
import CmsClient from '@/services/resource_client/cms'
import Notifier from '@/components/elements/Notifier'

export default {
  name: 'ParksCms',
  components: { Adminlte, Notifier },
  props: ['pageTitle', 'pageName'],
  data: function () {
    return {
      pageContent: {
        pageName: '',
        portugueseBody: '',
        englishBody: ''
      },
      activeContent: 'pt'
    }
  },
  mounted () {
    this.pageContent.pageName = this.pageName
    CmsClient.get(this.pageName)
    .then(r => { this.pageContent = r.data })
    .catch(e => {
      if (e.response.status !== 404) {
        throw e
      }
    })
  },
  methods: {
    showPtContent () {
      this.activeContent = 'pt'
    },
    showEnContent () {
      this.activeContent = 'en'
    },
    updatePortugueseData (data) {
      this.pageContent.portugueseBody = data
    },
    updateEnglishData (data) {
      this.pageContent.englishBody = data
    },
    save () {
      CmsClient.put(this.pageContent)
      .then(this.$refs.notifier.showSavedFormNotification())
    }
  }
}
</script>



// WEBPACK FOOTER //
// Cms.vue?d7d5e730